export const DEFAULT_LISTED_SINCE_YEARS = 3;
